(function($) {

	'use strict';

	var init = function() {
        videoPopup();
        initPopups();
	};

	var videoPopup = function(){

		$('.popVideo').click(function(e){

            e.stopPropagation();

            var video_url = $(this).data('video')

            if($('#videoPopUp video').attr('src') != video_url){
                $('#videoPopUp video').attr('src', video_url);
            }

            $('#videoPopUp video').get(0).currentTime = 0;
            $('#videoPopUp video').get(0).play();

            $('#videoPopUp').addClass('active');
            $('.buttonsSticky').hide();


        });

        $('#closeVideo').click(function(){

            $('#videoPopUp video').get(0).pause();
            $('#videoPopUp').removeClass('active');
            $('.buttonsSticky').show();
        });

        $('.flex-testimony__media__border').click(function(){

            $(this).toggleClass('active');
    
        });
	}

    function initPopups() {
        
        // Ouverture popup
        $('.popup-open').click(function(e) {
            e.preventDefault();
            e.stopPropagation();
            let popupId = $(this).data('popup');
            $('#popup-' + popupId).addClass('active');
        });

        // Fermeture popup
        $('.popup-close').click(function(e) {
            e.preventDefault();
            $(this).closest('.popup').removeClass('active');
        });

        // Fermeture popups via touche 'Esc' (page salon / home)
        window.onkeydown = function( event ) {
            if ( event.keyCode == 27 ) {
                $('.popup, #videoPopUp').removeClass('active');
                $('#videoPopUp video').get(0).pause();
            }
        };

        // Fermeture popups via clic en dehors (page salon / home)
        $('body').click(function() {
            if ($('.popup.active, #videoPopUp.active')[0]) {
                $('.popup, #videoPopUp').removeClass('active');
                $('#videoPopUp video').get(0).pause();
            }
        });

        $('.popup, #videoPopUp').click(function(e) {
            e.stopPropagation();
        });
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);